import {
  GET_HOTSPOT_CLICK,
  SET_HOTSPOT_CLICK,
} from "../constants/hotspot-click-constants";

const initialState = {
  status: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_HOTSPOT_CLICK:
      const { status } = action;
      return { ...state, status };
    default:
      return state;
  }
};
